import {
    BACK,
    BackAction,
    FirstVisitStep,
    CLOSE_FIRST_VISIT,
    CloseFirstVisitAction,
    FAILED,
    FailedAction,
    NEXT,
    NextAction,
    OPEN_FIRST_VISIT,
    OpenFirstVisitAction,
    SET_STEP,
    SetStepAction,
} from './types';

export function openFirstVisit(): OpenFirstVisitAction {
    return {
        type: OPEN_FIRST_VISIT,
    };
}

export function closeFirstVisit(): CloseFirstVisitAction {
    return {
        type: CLOSE_FIRST_VISIT,
    };
}

export function setStep(step: FirstVisitStep): SetStepAction {
    return {
        type: SET_STEP,
        payload: { step },
    };
}

export function next(): NextAction {
    return {
        type: NEXT,
    };
}

export function back(): BackAction {
    return {
        type: BACK,
    };
}

export function failed(error: string): FailedAction {
    return {
        type: FAILED,
        payload: { error },
    };
}
